export default "__VITE_ASSET__D_4r20Nc__"